import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { HhToastComponent } from './hh-toast';
import { HhToastService } from './hh-toast.service';

/**
 * Outlet for HhToastService. Place once, near the app root — anything
 * that injects the service can then show a toast without owning any
 * markup.
 */
@Component({
  selector: 'hh-toaster',
  standalone: true,
  imports: [HhToastComponent],
  template: `
    @if (toasts.current(); as toast) {
      <hh-toast [severity]="toast.severity" (dismissed)="toasts.dismiss()">{{ toast.text }}</hh-toast>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HhToasterComponent {
  protected readonly toasts = inject(HhToastService);
}
